import {
  Button,
  useTheme
} from '@mui/material';

import { authUtil } from 'modules/common';
import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { SaveProjectModal } from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import React, { useState } from 'react';



export type ProjectsHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectsHeaderSectionProps) => {



  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Projects'
      subtitle='Here is a list of projects.'
      actionButtons={(
        <ActionButtonsGroup />
      )}

      searchBar={(
        <>
        </>
      )}
    />
  );
};


type ActionButtonsGroupProps = {

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);


  const access = useAccessState('Project');

  return (
    <>
      {isVisible && (
        <SaveProjectModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Button
        disabled={!access.create}
        variant='contained'
        onClick={() => {
          setIsVisible(() => true);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create New Project
      </Button>
      <Button
        variant='contained'
        onClick={async () => {
          await authUtil.signOut();
        }}
      >
        Logout
      </Button>
    </>
  );
};

